var cards = [
	{
		"id": "WRW60",
		"productName": "Women's Wrangler® Ultimate Riding Jean Willow",
		"priceCurrent": {
			"formatted": "$59.00"
		},
		"title": "Quick View for Women's Wrangler® Ultimate Riding Jean Willow",
		"aria-label": "Quick View for Women's Wrangler® Ultimate Riding Jean Willow",
		"baseurl": "example/images/product/",
		"colorsRadio": [
			{
				"img": "assets/images/example/colors/WRW60AD-SW.webp",
				"title": "Della",
				"attr": {
					"productimage": "example/product/WRW60AD-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selected": true,
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60RA-SW.webp",
				"title": "Rebecca",
				"attr": {
					"productimage": "example/product/WRW60RA-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60DS-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/WRW60DS-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60UA-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/WRQ20JB-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60BE-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/WRQ20JB-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60LN-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/WRQ20JB-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			}
		],
		"gallery": [
			{
				"img": "assets/images/example/product-detail/product-10.webp",
				"imgBig": "assets/images/example/product-detail/product-10.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-10.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-11.webp",
				"imgBig": "assets/images/example/product-detail/product-11.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-11.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-12.webp",
				"imgBig": "assets/images/example/product-detail/product-12.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-12.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-13.webp",
				"imgBig": "assets/images/example/product-detail/product-13.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-13.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-14.webp",
				"imgBig": "assets/images/example/product-detail/product-14.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-14.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-15.webp",
				"imgBig": "assets/images/example/product-detail/product-15.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-15.webp"
			}
		],
		"rating": {
			"star": "4.5",
			"count": "4.5",
			"reviews": "33 reviews"
		},
		"color": "Della",
		"material": "77% Cotton/22% Polyester/1% Spandex; 11.75 oz. Stretch Denim"
	},
	{
		"id": "WRQ20",
		"productName": "Women's Wrangler® Ultimate Riding Jean Q-Baby",
		"priceCurrent": {
			"formatted": "$59.00"
		},
		"title": "Quick View for Women's Wrangler® Ultimate Riding Jean Q-Baby",
		"aria-label": "Quick View for Women's Wrangler® Ultimate Riding Jean Q-Baby",
		"baseurl": "example/images/product/",
		"colorsRadio": [
			{
				"img": "assets/images/example/colors/WRQ20JB-SW.webp",
				"title": "Briley",
				"attr": {
					"productimage": "example/product/WRQ20JB-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selected": true,
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRQ20QD-SW.webp",
				"title": "Dana",
				"attr": {
					"productimage": "example/product/WRQ20QD-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRQ20NR-SW.webp",
				"title": "NR Wash",
				"attr": {
					"productimage": "example/product/WRQ20NR-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60UA-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/WRQ20JB-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60BE-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/WRQ20JB-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60LN-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/WRQ20JB-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			}
		],
		"gallery": [
			{
				"img": "assets/images/example/product-detail/product-16.webp",
				"imgBig": "assets/images/example/product-detail/product-16.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-16.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-17.webp",
				"imgBig": "assets/images/example/product-detail/product-17.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-17.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-18.webp",
				"imgBig": "assets/images/example/product-detail/product-18.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-18.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-19.webp",
				"imgBig": "assets/images/example/product-detail/product-19.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-19.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-20.webp",
				"imgBig": "assets/images/example/product-detail/product-20.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-20.webp"
			}
		],
		"rating": {
			"star": "4.25",
			"count": "4.2",
			"reviews": "229 reviews"
		},
		"color": "Briley",
		"material": "77% Cotton/22% Polyester/1% Spandex; 11.75 oz. Stretch Denim"
	},
	{
		"id": "09RMZ",
		"productName": "Women's Wrangler Retro® Mae Jean",
		"priceCurrent": {
			"formatted": "$59.00"
		},
		"title": "Quick View for Women's Wrangler Retro® Mae Jean",
		"aria-label": "Quick View for Women's Wrangler Retro® Mae Jean",
		"baseurl": "example/images/product/",
		"colorsRadio": [
			{
				"img": "assets/images/example/colors/09MWZKS-SW.webp",
				"title": "Della",
				"attr": {
					"productimage": "example/product/09MWZKS-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selected": true,
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/09MWZRY-SW.webp",
				"title": "Rebecca",
				"attr": {
					"productimage": "example/product/09MWZRY-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/09MWZMS-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/09MWZMS-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60UA-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/WRQ20JB-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60BE-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/WRQ20JB-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60LN-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/WRQ20JB-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			}
		],
		"gallery": [
			{
				"img": "assets/images/example/product-detail/product-21.webp",
				"imgBig": "assets/images/example/product-detail/product-21.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-21.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-22.webp",
				"imgBig": "assets/images/example/product-detail/product-22.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-22.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-23.webp",
				"imgBig": "assets/images/example/product-detail/product-23.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-23.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-24.webp",
				"imgBig": "assets/images/example/product-detail/product-24.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-24.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-25.webp",
				"imgBig": "assets/images/example/product-detail/product-25.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-25.webp"
			}
		],
		"rating": {
			"star": "4.5",
			"count": "4.4",
			"reviews": "71 reviews"
		},
		"color": "Sloane",
		"material": "98% Cotton/2% Elastane; 10.5 oz. Stretch Denim"
	},
	{
		"id": "014MWZG",
		"productName": "Women's Wrangler® Cowboy Cut® Slim Fit Jean",
		"priceCurrent": {
			"formatted": "$59.00"
		},
		"title": "Quick View for Women's Wrangler® Cowboy Cut® Slim Fit Jean",
		"aria-label": "Quick View for Women's Wrangler® Cowboy Cut® Slim Fit Jean",
		"baseurl": "example/images/product/",
		"colorsRadio": [
			{
				"img": "assets/images/example/colors/014MWZG-SW.webp",
				"title": "Prewashed Indigo",
				"attr": {
					"productimage": "example/product/014MWZG-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selected": true,
				"selectable": true
			}
		],
		"gallery": [
			{
				"img": "assets/images/example/product-detail/product-26.webp",
				"imgBig": "assets/images/example/product-detail/product-26.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-26.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-27.webp",
				"imgBig": "assets/images/example/product-detail/product-27.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-27.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-28.webp",
				"imgBig": "assets/images/example/product-detail/product-28.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-28.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-29.webp",
				"imgBig": "assets/images/example/product-detail/product-29.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-29.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-30.webp",
				"imgBig": "assets/images/example/product-detail/product-30.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-30.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-31.webp",
				"imgBig": "assets/images/example/product-detail/product-31.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-31.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-32.webp",
				"imgBig": "assets/images/example/product-detail/product-32.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-32.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-33.webp",
				"imgBig": "assets/images/example/product-detail/product-33.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-33.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-34.webp",
				"imgBig": "assets/images/example/product-detail/product-34.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-34.webp"
			}
		],
		"rating": {
			"star": "4",
			"count": "4",
			"reviews": "289 reviews"
		},
		"color": "Prewashed Indigo",
		"material": "100% Cotton Heavyweight Denim, 14.75 oz."
	},
	{
		"id": "11MPEDE",
		"productName": "Women's Wrangler Retro® Premium High Rise Trouser Jean",
		"priceCurrent": {
			"formatted": "$79.00"
		},
		"title": "Quick View for Women's Wrangler Retro® Premium High Rise Trouser Jean",
		"aria-label": "Quick View for Women's Wrangler Retro® Premium High Rise Trouser Jean",
		"baseurl": "example/images/product/",
		"colorsRadio": [
			{
				"img": "assets/images/example/colors/11MPEDE-SW.webp",
				"title": "Diane",
				"attr": {
					"productimage": "example/product/11MPEDE-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selected": true,
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/11MPEAB-SW.webp",
				"title": "Blair",
				"attr": {
					"productimage": "example/product/11MPEAB-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/11MPESY-SW.webp",
				"title": "Shelby",
				"attr": {
					"productimage": "example/product/11MPESY-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			}
		],
		"gallery": [
			{
				"img": "assets/images/example/product-detail/product-35.webp",
				"imgBig": "assets/images/example/product-detail/product-35.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-35.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-36.webp",
				"imgBig": "assets/images/example/product-detail/product-36.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-36.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-37.webp",
				"imgBig": "assets/images/example/product-detail/product-37.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-37.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-38.webp",
				"imgBig": "assets/images/example/product-detail/product-38.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-38.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-39.webp",
				"imgBig": "assets/images/example/product-detail/product-39.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-39.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-40.webp",
				"imgBig": "assets/images/example/product-detail/product-40.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-40.webp"
			}
		],
		"rating": {
			"star": "5",
			"count": "5",
			"reviews": "11 reviews"
		},
		"color": "Diane",
		"material": "98% Cotton/2% Spandex; 11.25 oz. Stretch Denim"
	},
	{
		"id": "09RMST",
		"productName": "Women's Wrangler Retro® Premium High Rise Trumpet Flare Jean",
		"priceCurrent": {
			"formatted": "$79.00"
		},
		"title": "Quick View for Women's Wrangler Retro® Premium High Rise Trumpet Flare Jean",
		"aria-label": "Quick View for Women's Wrangler Retro® Premium High Rise Trumpet Flare Jean",
		"baseurl": "example/images/product/",
		"colorsRadio": [
			{
				"img": "assets/images/example/colors/11MPFLM-SW.webp",
				"title": "Della",
				"attr": {
					"productimage": "example/product/11MPFLM-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selected": true,
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/11MPFEH-SW.webp",
				"title": "Rebecca",
				"attr": {
					"productimage": "example/product/11MPFEH-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			}
		],
		"gallery": [
			{
				"img": "assets/images/example/product-detail/product-16.webp",
				"imgBig": "assets/images/example/product-detail/product-16.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-16.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-17.webp",
				"imgBig": "assets/images/example/product-detail/product-17.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-17.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-18.webp",
				"imgBig": "assets/images/example/product-detail/product-18.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-18.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-19.webp",
				"imgBig": "assets/images/example/product-detail/product-19.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-19.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-20.webp",
				"imgBig": "assets/images/example/product-detail/product-20.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-20.webp"
			}
		],
		"rating": {
			"star": "4.5",
			"count": "4.5",
			"reviews": "33 reviews"
		},
		"color": "Sally",
		"material": "98% Cotton/2% Elastane; 10.5 oz. Stretch Denim"
	},
	{
		"id": "09MWTSY",
		"productName": "Women's Wrangler Retro® Mae Straight Leg Jean",
		"priceCurrent": {
			"formatted": "$59.00"
		},
		"title": "Quick View for Women's Wrangler Retro® Mae Straight Leg Jean",
		"aria-label": "Quick View for Women's Wrangler Retro® Mae Straight Leg Jean",
		"baseurl": "example/images/product/",
		"colorsRadio": [
			{
				"img": "assets/images/example/colors/09MWTSY-SW.webp",
				"title": "Sally",
				"attr": {
					"productimage": "example/product/09MWTSY-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selected": true,
				"selectable": true
			}
		],
		"gallery": [
			{
				"img": "assets/images/example/product-detail/product-16.webp",
				"imgBig": "assets/images/example/product-detail/product-16.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-16.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-17.webp",
				"imgBig": "assets/images/example/product-detail/product-17.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-17.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-18.webp",
				"imgBig": "assets/images/example/product-detail/product-18.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-18.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-19.webp",
				"imgBig": "assets/images/example/product-detail/product-19.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-19.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-20.webp",
				"imgBig": "assets/images/example/product-detail/product-20.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-20.webp"
			}
		],
		"rating": {
			"star": "5",
			"count": "5",
			"reviews": "2 reviews"
		},
		"color": "Dillon",
		"material": "98% Cotton/2% Elastane; 8.9 oz. Stretch Denim"
	},
	{
		"id": "09MWWUD",
		"productName": "Women's Wrangler Retro® Mae Wide Leg Trouser Jean",
		"priceCurrent": {
			"formatted": "$59.00"
		},
		"title": "Quick View for Women's Wrangler Retro® Mae Wide Leg Trouser Jean",
		"aria-label": "Quick View for Women's Wrangler Retro® Mae Wide Leg Trouser Jean",
		"baseurl": "example/images/product/",
		"colorsRadio": [
			{
				"img": "assets/images/example/colors/09MWWUD-SW.webp",
				"title": "Dillon",
				"attr": {
					"productimage": "example/product/09MWWUD-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selected": true,
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/09MWWVI-SW.webp",
				"title": "Vicki",
				"attr": {
					"productimage": "example/product/09MWWVI-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/09MWWHA-SW.webp",
				"title": "Alice",
				"attr": {
					"productimage": "example/product/09MWWHA-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60UA-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/09MWTSY-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60BE-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/09MWTSY-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60LN-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/09MWTSY-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			}
		],
		"gallery": [
			{
				"img": "assets/images/example/product-detail/product-16.webp",
				"imgBig": "assets/images/example/product-detail/product-16.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-16.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-17.webp",
				"imgBig": "assets/images/example/product-detail/product-17.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-17.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-18.webp",
				"imgBig": "assets/images/example/product-detail/product-18.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-18.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-19.webp",
				"imgBig": "assets/images/example/product-detail/product-19.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-19.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-20.webp",
				"imgBig": "assets/images/example/product-detail/product-20.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-20.webp"
			}
		],
		"rating": {
			"star": "4.25",
			"count": "4.3",
			"reviews": "45 reviews"
		},
		"color": "M Wash",
		"material": "98% Cotton/2% Elastane; 10.5 oz. Stretch Denim"
	},
	{
		"id": "09MWZLM",
		"productName": "Women's Bootcut Jean",
		"priceCurrent": {
			"formatted": "$39.00"
		},
		"title": "Quick View for Women's Bootcut Jean",
		"aria-label": "Quick View for Women's Bootcut Jean",
		"baseurl": "example/images/product/",
		"colorsRadio": [
			{
				"img": "assets/images/example/colors/09MWZLM-SW.webp",
				"title": "Maria",
				"attr": {
					"productimage": "example/product/09MWZLM-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selected": true,
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/09MWZMB-SW.webp",
				"title": "MB Wash",
				"attr": {
					"productimage": "example/product/09MWZMB-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/09MWZDO-SW.webp",
				"title": "DO Wash",
				"attr": {
					"productimage": "example/product/09MWZDO-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60UA-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/09MWWUD-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60BE-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/09MWWUD-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60LN-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/09MWWUD-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			}
		],
		"gallery": [
			{
				"img": "assets/images/example/product-detail/product-16.webp",
				"imgBig": "assets/images/example/product-detail/product-16.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-16.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-17.webp",
				"imgBig": "assets/images/example/product-detail/product-17.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-17.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-18.webp",
				"imgBig": "assets/images/example/product-detail/product-18.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-18.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-19.webp",
				"imgBig": "assets/images/example/product-detail/product-19.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-19.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-20.webp",
				"imgBig": "assets/images/example/product-detail/product-20.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-20.webp"
			}
		],
		"rating": {
			"star": "0",
			"count": "0.0",
			"reviews": "No Reviews"
		},
		"color": "Maria",
		"material": "98% Cotton/2% Elastane; 10.5 oz. Stretch Denim"
	},
	{
		"id": "09MWTMN",
		"productName": "Women's Straight Leg Jean",
		"priceCurrent": {
			"formatted": "$19.00"
		},
		"title": "Quick View for Women's Straight Leg Jean",
		"aria-label": "Quick View for Women's Straight Leg Jean",
		"baseurl": "example/images/product/",
		"colorsRadio": [
			{
				"img": "assets/images/example/colors/09MWTMN-SW.webp",
				"title": "Madelyn",
				"attr": {
					"productimage": "example/product/09MWTMN-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selected": true,
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/09MWTDS-SW.webp",
				"title": "DS Wash",
				"attr": {
					"productimage": "example/product/09MWTDS-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/09MWTMS-SW.webp",
				"title": "MS Wash",
				"attr": {
					"productimage": "example/product/09MWTMS-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60UA-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/09MWZLM-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60BE-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/09MWZLM-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60LN-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/09MWZLM-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			}
		],
		"gallery": [
			{
				"img": "assets/images/example/product-detail/product-16.webp",
				"imgBig": "assets/images/example/product-detail/product-16.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-16.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-17.webp",
				"imgBig": "assets/images/example/product-detail/product-17.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-17.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-18.webp",
				"imgBig": "assets/images/example/product-detail/product-18.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-18.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-19.webp",
				"imgBig": "assets/images/example/product-detail/product-19.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-19.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-20.webp",
				"imgBig": "assets/images/example/product-detail/product-20.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-20.webp"
			}
		],
		"rating": {
			"star": "4.25",
			"count": "4.2",
			"reviews": "29 reviews"
		},
		"color": "Madelyn",
		"material": "98% Cotton/2% Elastane; 10.5 oz. Stretch Denim"
	},
	{
		"id": "11MPSLH",
		"productName": "Women's Wrangler Retro® Premium High Rise Skinny Jean",
		"priceCurrent": {
			"formatted": "$79.00"
		},
		"title": "Quick View for Women's Wrangler Retro® Premium High Rise Skinny Jean",
		"aria-label": "Quick View for Women's Wrangler Retro® Premium High Rise Skinny Jean",
		"baseurl": "example/images/product/",
		"colorsRadio": [
			{
				"img": "assets/images/example/colors/11MPSLH-SW.webp",
				"title": "Leah",
				"attr": {
					"productimage": "example/product/11MPSLH-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selected": true,
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/11MPSFH-SW.webp",
				"title": "Faith",
				"attr": {
					"productimage": "example/product/11MPSFH-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/11MPSDN-SW.webp",
				"title": "Devon",
				"attr": {
					"productimage": "example/product/11MPSDN-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			}
		],
		"gallery": [
			{
				"img": "assets/images/example/product-detail/product-16.webp",
				"imgBig": "assets/images/example/product-detail/product-16.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-16.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-17.webp",
				"imgBig": "assets/images/example/product-detail/product-17.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-17.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-18.webp",
				"imgBig": "assets/images/example/product-detail/product-18.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-18.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-19.webp",
				"imgBig": "assets/images/example/product-detail/product-19.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-19.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-20.webp",
				"imgBig": "assets/images/example/product-detail/product-20.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-20.webp"
			}
		],
		"rating": {
			"star": "4.25",
			"count": "4.2",
			"reviews": "13 reviews"
		},
		"color": "Leah",
		"material": "86% Cotton/13% Polyester/1% Spandex; 9.8 oz. Stretch Denim"
	},
	{
		"id": "WUT74HN",
		"productName": "Aura from the Women at Wrangler® Instantly Slimming™ Jean",
		"priceCurrent": {
			"formatted": "$59.00"
		},
		"title": "Quick View for Aura from the Women at Wrangler® Instantly Slimming™ Jean",
		"aria-label": "Quick View for Aura from the Women at Wrangler® Instantly Slimming™ Jean",
		"baseurl": "example/images/product/",
		"colorsRadio": [
			{
				"img": "assets/images/example/colors/WUT74HN-SW.webp",
				"title": "Helen",
				"attr": {
					"productimage": "example/product/WUT74HN-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selected": true,
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WUT74BT-SW.webp",
				"title": "BT Wash",
				"attr": {
					"productimage": "example/product/WUT74BT-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WUT74TM-SW.webp",
				"title": "Tinted Mid-stone",
				"attr": {
					"productimage": "example/product/WUT74TM-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60UA-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/11MPSLH-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60BE-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/11MPSLH-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			},
			{
				"img": "assets/images/example/colors/WRW60LN-SW.webp",
				"title": "Davis",
				"attr": {
					"productimage": "example/product/11MPSLH-HERO.webp",
					"producturl": "#",
					"product-change": ""
				},
				"selectable": true
			}
		],
		"gallery": [
			{
				"img": "assets/images/example/product-detail/product-16.webp",
				"imgBig": "assets/images/example/product-detail/product-16.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-16.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-17.webp",
				"imgBig": "assets/images/example/product-detail/product-17.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-17.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-18.webp",
				"imgBig": "assets/images/example/product-detail/product-18.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-18.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-19.webp",
				"imgBig": "assets/images/example/product-detail/product-19.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-19.webp"
			},
			{
				"img": "assets/images/example/product-detail/product-20.webp",
				"imgBig": "assets/images/example/product-detail/product-20.webp",
				"imgThumb": "assets/images/example/product-detail/product_thumb-20.webp"
			}
		],
		"rating": {
			"star": "4",
			"count": "4.1",
			"reviews": "232 reviews"
		},
		"color": "Helen",
		"material": "98% Cotton/2% Elastane; 10.5 oz. Stretch Denim"
	}
];

window.cards = cards;
